import { createFileRoute } from "@tanstack/react-router";

import { FraudPage } from "../../../features/shipping/fraud-page";

export const Route = createFileRoute("/_app/settings/fraud")({ component: FraudPage });
